<template>
  <ul class="nav justify-content-start lasubnav d-flex flex-wrap align-items-center py-1">
    <li class="nav-item">
      <router-link :to="indexLink" class="nav-link text-white" active-class="active">Inventario</router-link>
    </li>
    <li class="nav-item">
      <router-link :to="categoriasDeInventarioLink" class="nav-link text-white" active-class="active">Categorías</router-link>
    </li>
    <li class="nav-item">
      <router-link :to="marcasdeProductosLink" class="nav-link text-white" active-class="active">Marcas de productos</router-link>
    </li>
    <li class="nav-item">
      <router-link :to="consultaDePrecioLink" class="nav-link text-white" active-class="active">Consulta de precio</router-link>
    </li>
    <v-guard :permissions="['STOCK_MOVIMIENTO']">
      <li class="nav-item">
        <router-link :to="existenciasEnStockLink" class="nav-link text-white" active-class="active">Existencias en stock</router-link>
      </li>
      <li class="nav-item">
        <router-link :to="movimientosDeStockLink" class="nav-link text-white" active-class="active">Movimientos de stock</router-link>
      </li>
    </v-guard>
    <v-guard :permissions="['OFFERS_MANAGE']">
      <li class="nav-item">
        <router-link :to="ofertasLink" class="nav-link text-white" active-class="active">Ofertas</router-link>
      </li>
    </v-guard>
    <v-guard :permissions="['PRECIOS_ACTUALIZADOR']">
      <li class="nav-item">
        <router-link :to="actualizacionDePreciosLink" class="nav-link text-white" active-class="active">Actualización de precios</router-link>
      </li>
      <li class="nav-item">
        <router-link :to="listasDePreciosLink" class="nav-link text-white" active-class="active">Listas de precios</router-link>
      </li>
    </v-guard>
    <li class="nav-item">
      <router-link :to="depositosLink" class="nav-link text-white" active-class="active">Depósitos</router-link>
    </li>
    <!-- <li class="nav-item"><router-link :to="transferLink" class="nav-link" active-class="active">Transferencia de stock</router-link></li> -->
  </ul>
</template>

<script>
export default {
  computed: {
    indexLink() {
      return { name: 'Inventario' }
    },
    categoriasDeInventarioLink() {
      return { name: 'Categorias de inventario' }
    },
    marcasdeProductosLink() {
      return { name: 'Marcas de productos' }
    },
    existenciasEnStockLink() {
      return { name: 'Existencias en stock' }
    },
    consultaDePrecioLink() {
      return { name: 'Consulta de Precio' }
    },
    movimientosDeStockLink() {
      return { name: 'Movimientos de stock' }
    },
    actualizacionDePreciosLink() {
      return { name: 'Actualizacion de precios' }
    },
    listasDePreciosLink() {
      return { name: 'Listas de precios' }
    },
    
    catalogosLink() {
      return { name: 'Catalogos' }
    },
    depositosLink() {
      return { name: 'Depositos' }
    },
    ofertasLink() {
      return { name: 'Ofertas' }
    },
    /* transferLink() {
      return { name: 'Transferencia de Stock' }
    }, */
  }
}
</script>

<style scoped>
.lasubnav {
  animation: opacity 0.2s cubic-bezier(0.65, 0.05, 0.36, 1);
  background: #2d538a;
  /* justify-content-start deja el primer item pegado al borde; antes con
     center no se notaba la falta de aire de este lado. */
  padding-left: 1rem;
}

.lasubnav .nav-link {
  padding: 11px;
  color: white;
  font-weight: bold;
}

.lasubnav .nav-link:not(.active) {
  font-weight: normal;
  letter-spacing: 0.01em;
}

.lasubnav .nav-link:hover,
.lasubnav .nav-link:focus {
  color: white;
}

@keyframes opacity {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.active {
  font-weight: bold;
  color: white; 
  background-color: #4477bd;
  border-radius: 4px;
}
</style>